import { CARD_FORM } from '../form-card-type';
import { dropdown } from '../../../dropdown';

import { ICardGroupInsertUpdate } from '../../../../models/cardgroup.interface';
import GetCardGroups from '../../../../routes/get-card-groups';

/**
 * Function to change the card group dropdown
 * 
 * @param {string} newCustomerID the new customer ID
 * 
 * @returns void
 */
export const changeCustomerCardGroup = async (newCustomerID: string) => {
  const { body } = await GetCardGroups(newCustomerID);

  const cardGroupList = body.map((r: ICardGroupInsertUpdate) => ({ id: r.cardGroupId, name: r.cardGroupName }));

  dropdown(cardGroupList, 'card-group', 'Card Group', true, true);
  CARD_FORM.cardCardGroup.innerText = 'Please Select New Card Group';
}